module.exports = __webpack_public_path__ + "static/img/31-3.4c12fe5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/31-3.jpg
// module id = 2NE9
// module chunks = 0